import ajax from './ajax.js'

export default ajax



// WEBPACK FOOTER //
// ./src/utils/ajax/index.js